var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[(_vm.showHead)?_c('div',{class:_vm.headClasses},[_vm._t("title")],2):_vm._e(),_vm._v(" "),(_vm.showExtra)?_c('div',{class:_vm.extraClasses},[_vm._t("extra")],2):_vm._e(),_vm._v(" "),_c('div',{class:_vm.bodyClasses,style:(_vm.bodyStyles)},[_vm._t("default")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/card/card.vue